/**
 * Auth Sync
 *
 * Mirrors the SSO session into localStorage under generic keys so the
 * rest of the app (and quick debugging) can read them without touching
 * the SSO provider directly.
 */

import { AUTH_CONFIG, USER_ROLES } from '@/config/constants';
import { getAppRoles, getSsoIdentity } from './sso';

const ROLE_PRIORITY: string[] = [
  USER_ROLES.SUPERUSER,
  USER_ROLES.COMERCIAL,
  USER_ROLES.MARKETING,
];

/**
 * Pick the user's primary Contacts role from the app roles list.
 */
export const resolvePrimaryRole = (roles: string[]): string | null =>
  ROLE_PRIORITY.find((role) => roles.includes(role)) ?? null;

/**
 * Persist token, role and identity under generic localStorage keys.
 */
export const syncAuthData = (token: string | null): void => {
  const roles = getAppRoles();
  const identity = getSsoIdentity();

  if (token) {
    localStorage.setItem(AUTH_CONFIG.TOKEN_KEY, token);
  }
  localStorage.setItem(AUTH_CONFIG.ROLE_KEY, resolvePrimaryRole(roles) ?? '');
  localStorage.setItem(AUTH_CONFIG.ROLES_KEY, JSON.stringify(roles));
  localStorage.setItem(AUTH_CONFIG.USER_KEY, JSON.stringify(identity));
  localStorage.setItem(AUTH_CONFIG.AUTH_METHOD_KEY, 'sso');
};
